import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

import { colors } from '../../../core';

interface TooltipProps {
  id: string;
  text?: string;
  textColor?: string;
  opacity?: number;
  children?: React.ReactNode;
  backgroundColor?: string;
}

const StyledReactTooltip = styled(ReactTooltip)`
  opacity: ${({ opacity }) => opacity || 1} !important;
  box-shadow: 0 2px 4px 0 rgba(217, 217, 217, 0.5);
`;

const Tooltip = ({ id, text, textColor, opacity, children, backgroundColor }: TooltipProps) => (
  <StyledReactTooltip
    id={id}
    opacity={opacity}
    textColor={textColor || colors.primary}
    backgroundColor={backgroundColor || colors.white}
  >
    {children ? children : text}
  </StyledReactTooltip>
);

export default Tooltip;
